import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {
	DeleteNovaAgentCategoryInput,
	DeleteNovaAgentCategoryMutation,
} from './__generated__/DeleteNovaAgentCategoryMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// The server reassigns the category's agents to Uncategorised as part of the delete (see
// `reassignedAgentCount`). Like `CreateNovaAgentCategoryMutation`, the catalogue
// (`viewer.novaAgentCatalogue`) is a plain list with no `@connection` to update in place, so the
// caller refetches the catalogue in `onSuccess` to reflect both the removed category and its
// former agents' new Uncategorised membership.
const mutation = graphql`
	mutation DeleteNovaAgentCategoryMutation($input: DeleteNovaAgentCategoryInput!) {
		deleteNovaAgentCategory(input: $input) {
			deletedCategoryId
			reassignedAgentCount
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<DeleteNovaAgentCategoryInput>,
	onSuccess?: RelayOnCompleted<DeleteNovaAgentCategoryMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<DeleteNovaAgentCategoryMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
